export default {
	login: {
		loginTitle: 'Welcome to',
		loginTitlefont: 'Please sign in to begin your journey.',
		inputNameFonts: 'Email Address',
		inputName: 'Enter Your Email',
		inputPasswordFonts: 'Password',
		inputPassword: 'Enter Your Password',
		ForgotPassword: 'Forgot Password ?',
		loginButton: 'Continue',
		SignUp: "Don't have an account?",
		SignUpA: 'Sign up',
		googleButton: 'Continue with google',
		errorFonts: 'The account or password you entered is incorrect!',
		outLogin: 'log out',
	},
	phoneLogin:{
		title:'Log in',
		loginQR:'Login with QRcode',
		loginPass:'Log in with password',
		verificationCode:'code',
		SendverificationCode:'Send verification code',
		loginBut:'Log in',
		submit:'Submit',
		explain:'Slide to complete the puzzle',
		veifyTitle:'Please complete security verification',
		verificationCodeLogin:'Log in with code',
		passwordLogin:'password',
		EmailRetrievePassword:'Email retrieve password',
		forgotPassword:'Forgot Password',
		emailLogin:'Email login',
		loginWithQRcode:'Login with QRcode',
		loginWithMobiles:'Login with mobiles',
		getPasswordSendCode:'code',
		loginByOtherMeans:'Login by other means',
		// 登录方式标题title
		getBackPhonePassword:'Mobiles retrieve password',
		getEmailPassword:'Email retrieve password',
		// 输入框标识
		emailInput:'Email',
		emailInputPass:'Password',
		Phoneplaceholder:'Please enter phone number',
		phonePasswordPlaceholder:'Please enter Verification code',
		importPassword:'Please enter password',
		// 弹窗提示
		emailPasswordInputError:'Account name cannot be empty!The password must be at least 6 characters!',
		errorMessageTitle:'Error message',
		MessageButton:'confirm',
		// emailPasswordLoginError:'Incorrect email or password',
		getCodeError:'The CAPTCHA has reached its upper limit today',
		phoneNumberError:'The phone number is incorrect',
		errorPhoneCode:'The verification code is incorrect',
		emptyInput:'Please enter the phone number verification code or password',
		errorPhoneOrPassword:'The phone number or password is incorrect',
		errorPhoneNumber:'The phone number is incorrect',
		incorrectEmail:'Incorrect email',
		PleaseTryAgainLater:'Please try again later',
		ThePhoneNumberIsNotYetRegistered:'The phone number is not yet registered',
		TheEmailrIsNotYetRegistered:'The email is not yet registered',
		successMessageTitle:'Success message',
		// resetSuccessfully:'Reset successfully',
		errorLoginPassword:'Please enter your login password',
		failtoSend:'fail to send',
		// 二维码登录提示
		qrTitles:'Open KOKONI3D APP->Account->Scan',
		qrcodeSuccessTitle:'login successfully',
	},
	pricing: {
		pricingTitle: 'Subscription Plan',
	},
	home: {
		headerLanguage: 'English',
		headerLogin: 'Login/Signup'
	},
	content: {
		typeface1: "Assist everyone in realizing their creativity",
		// typeface2: "3D Creativity",
		fontsname: 'AI-Powered 3D Generation',
		buttonLeft: 'Try Now-it`s free',
		buttonRight: 'View price&APi',
		buttonButtom: 'Download App',
		technologyFont: 'See Our Technology in Action',
		littleFont: 'Our early adopters have shared enthusiastic and positive feedback.',
		swiperFont: 'Community Showcase',
		swiperFontmin1: 'Get inspired by how our community members are leveragin the power of sudoAl to',
		swiperFontmin2: 'create 3D content from text or image.'
	},
	footerTitle: {
		titlename: 'Stay turned by joining our e-mail list',
		footerBottomName: 'Copyright © SUDOAI | All Rights Reserved'
	},
	accountRecord: {
		apiKeys: 'API keys',
		Usage: 'Usage',
		RencentModels: 'Rencent Models',
		CurrentPlan: 'Current Plan',
		free: 'Free',
		PerMonth: 'Per month',
		MonthlyCredit: 'Monthly Credit',
		ApiAccess: 'API access',
		UpgradeNow: 'Upgrade Now',
		credits: 'Credits',
		Left: 'Left',
		MonthlyCredit: 'Monthly Credit',
		PermanentCredits: 'Permanent credits',
		addCredits: 'Add Credits',
		GetFreeCredis: 'Get Free Credis?',
		GetFreeCredits: 'Get Free Credits',
		GetFreeCreditsFontsTop: 'Free Users Receive',
		GetFreeCreditsFontsTop2: '40 Monthly',
		GetFreeCreditsFontsTop3: 'Credits That Reset At 00:00 (UTC) On The 1st Of Every Month.',
		GetFreeCreditsFontsBottom: 'Sharing Your 3D Generation Results On Twitter Will Allow You To Earn ',
		GetFreeCreditsFontsBottom2: 'Anadditional 10 Credits ',
		GetFreeCreditsFontsBottom3: ', With A Maximum Of 100 Credits Per Month.',
		PurchaseExtraCredit: 'Purchase extra credit',
		PurchaseExtraCreditMoneyLeft: '$0',
		PurchaseExtraCreditExplainLeft: '40 credits',
		PurchaseExtraCreditMoneyRight: '$16',
		PurchaseExtraCreditExplainRight: '160 credits',
	},
	APIKeys: {
		APIKeys: 'API Keys',
		UpgradeAPIKeys: 'Upgrade your subscription plan to enable API access.',
		APIReference: 'API Reference',
	},
	Usage: {
		Usage: 'Usage',
		UsageCredits: 'Your credits usage list including app and api.',
	},
	rencentModels: {
		rencentModels: 'My Models',
		rencentModelsModeled: 'Here is the model you have already modeleds',
	},
	Generate3D: {
		Generate3D: 'Generate 3D',
		ImageTo3D: 'Image to 3D',
		TextTo3D: 'Text to 3D',
		explain: 'Please upload an image featuring a single complete object in a front view against a clear background. Tutorial',
		SelectFromExamples: 'Select from examples',
		AccountSettings: 'Account Settings',
		outLogin: 'Logout',
		AssistantPanel: 'Assistant Panel',
		SimilarExistingModels: 'Similar Existing Models',
		History: 'History',
	},
	cashierdeskMain:{
		cashierdeskTitle:'向sudoAI .inc.支付',
		
	}
};
